<template>
  <div>
    <form
        v-on:submit.prevent="handleCreateProduct">
      <div>
        <label
            for="email"
            class="block text-sm font-medium text-gray-700">
          Name
        </label>
        <div
            class="mt-1 relative rounded-md shadow-sm">
          <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <ShoppingCartIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true" />
          </div>
          <input
              @input="v$.product.name.$touch"
              v-model="product.name"
              type="text"
              name="email"
              id="email"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
              placeholder="Product Name" />

        </div>
        <div
            v-if="v$.product.name.$dirty"
            v-for="error in v$.product.name.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
      </div>
      <div class="mt-3">
        <primary-button
            :disabled="v$.$invalid"
            @click="handleCreateProduct"
            text="Create Product" />
      </div>
    </form>
  </div>
</template>

<script>
import { ShoppingCartIcon } from '@heroicons/vue/solid'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "ProductsForm",
  components: {
    ShoppingCartIcon,
    PrimaryButton
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      product: {
        name: '',
        clientId: parseInt(this.$route.params.id),
      },

    }
  },
  methods: {
    async handleCreateProduct() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('createProduct', this.product)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Product Successfully Created'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('closeCreateProductPanel')
      this.$store.dispatch('hideLoadingSpinner')

    }
  },
  validations: {
    product: {
      name: { required }
    }
  }
}
</script>

<style scoped>

</style>
